import React, { useState } from "react";
import { FaFilePdf, FaTimes } from "react-icons/fa";

import "./DocumentosGestion.css";

// PDFs
import pdfPEI from "../assets/transparencia/doc_gestion/PEI_2026.pdf";
import pdfRegistro from "../assets/transparencia/doc_gestion/ManualRegistraGilda.pdf";
import pdfTitula from "../assets/transparencia/doc_gestion/ManualTitulaGilda.pdf";
import pdfPAT from "../assets/transparencia/doc_gestion/PAT_2026_Director.pdf";
import pdfResolucion from "../assets/transparencia/doc_gestion/resolucionPlanesEstudio.pdf";
import pdf1GestionAdmin from "../assets/transparencia/doc_gestion/1GestionAdmin.pdf";
import pdf2Contabilidad from "../assets/transparencia/doc_gestion/2Contabilidad.pdf";
import pdf3DesarrolloSistemas from "../assets/transparencia/doc_gestion/3DesarrolloSistemas.pdf";
import pdf4ElectronicaIndus from "../assets/transparencia/doc_gestion/4ElectronicaIndus.pdf";
import pdf5ElectricidadIndus from "../assets/transparencia/doc_gestion/5ElectricidadIndus.pdf";
import pdf6Civil from "../assets/transparencia/doc_gestion/6Civil.pdf";
import pdf7MecatronicaAuto from "../assets/transparencia/doc_gestion/7MecatronicaAuto.pdf";
import pdf8MecanicaProduc from "../assets/transparencia/doc_gestion/8MecanicaProduc.pdf";


const documentos = [
  { titulo: "PEI 2026-2032", pdf: pdfPEI },
  { titulo: "MANUAL DEL SISTEMA DE REGISTRO ACADÉMICO", pdf: pdfRegistro },
  { titulo: "MANUAL DEL SISTEMA TITULA", pdf: pdfTitula },
  { titulo: "PAT 2026", pdf: pdfPAT },
  { titulo: "Resolucion Aprobación Planes Estudio 2023", pdf: pdfResolucion },
  { titulo: "Perfil de Puestos Gestión Administrativa", pdf: pdf1GestionAdmin },
  { titulo: "Perfil de Puestos Contabilidad", pdf: pdf2Contabilidad },
  { titulo: "Perfil de Puestos Desarrollo Sistemas", pdf: pdf3DesarrolloSistemas },
  { titulo: "Perfil de Puestos Electrónica Industrial", pdf: pdf4ElectronicaIndus },
  { titulo: "Perfil de Puestos Electricidad Industrial", pdf: pdf5ElectricidadIndus },
  { titulo: "Perfil de Puestos Construcción Civil", pdf: pdf6Civil },
  { titulo: "Perfil de Puestos Mecatrónica Automotriz", pdf: pdf7MecatronicaAuto },
  { titulo: "Perfil de Puestos Mecánica Producción", pdf: pdf8MecanicaProduc },
];

const DocumentosGestion = () => {
  const [selectedPdf, setSelectedPdf] = useState(null);

  const handleOpenPdf = (pdf) => {
    setSelectedPdf(pdf);
    document.body.style.overflow = "hidden"; 
  };

  const handleClosePdf = () => {
    setSelectedPdf(null);
    document.body.style.overflow = "auto"; 
  };

  return (
    <section className="doc-page py-5">
       {/* Banner superior */}
       <div className="info-hero" 
      >
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Documentos de Gestión Institucional</h1>
          <p className="lead">
            Accede a los principales instrumentos de gestión del IESTP .
          </p>
        </div>
      </div>


      <div className="container text-center">
        

        <div className="row g-4 justify-content-center">
          {documentos.map((doc, index) => (
            <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
              <div className="pdf-card shadow-sm rounded-4 bg-white p-4 text-center">
                <div className="doc-icon mb-3">
                  <FaFilePdf size={80} color="#c62828" />
                </div>
                <h5 className="fw-bold mb-3 text-primary">{doc.titulo}</h5>
                <button
                  onClick={() => handleOpenPdf(doc.pdf)}
                  className="btn btn-doc"
                >
                  <FaFilePdf className="me-2" /> Ver Documento
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

   
      {selectedPdf && (
        <div className="pdf-modal" onClick={handleClosePdf}>
          <div
            className="pdf-modal-content-wide"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={handleClosePdf}>
              <FaTimes size={20} />
            </button>
            <iframe
              src={`${selectedPdf}#view=FitH`}
              title="Vista PDF"
              className="pdf-full-view-wide"
            ></iframe>
          </div>
        </div>
      )}
    </section>
  );
};

export default DocumentosGestion;
